import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';
import { Subject } from 'rxjs';
import { GlobalClassInstance } from '../constants/GlobalClass';
import { LocalStorageSvc } from './localStorage.service';
import { UniversalService } from './universal.service';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  historyList:any=[];
  searchHistory:string[] = [];
  teamFolderSearchHistory:any = [];
  readonly maxSearchHistory:number =5;
  searchQuerySuggestions:any;
  suggestedKeywordResults ;
  queryResults = {};
  searchQuerySubscriptionList:object= {};
  openAutoSearch:Subject<boolean> = new Subject();
  updatePlaceholder:Subject<boolean> = new Subject();
  prevKeywordSearched:string;
  lastSearchQuery:string|null;
  userData : any;
  //aiSearchToggleEnabled : boolean = false;
  searchUrl:any = '';
  constructor(
    private http:HttpClient,
    private universalService:UniversalService,
    public localStorageService:LocalStorageSvc
  ) { 
    this.getSearchHistory();
  }

 /** function to fetch  suggesstions for a keyword/search query */
 
  searchQuery(val){
    let self = this;
    return new Promise((resolve, reject) => {
      // if(this.queryResults[val]){
      //    resolve(this.queryResults[val]);
      // } else{

        val =encodeURIComponent(val);
        let limit = 50 * ENV_CONFIG["constants"]["PAGINATION_BUFFER"];
        //var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["aseURL"] + ENV_CONFIG.commonUrls["searchQuery"] + "?param=" + val + "&context=myfiles&page=0&limit=" + limit;        
        var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["aseURL"] + ENV_CONFIG.commonUrls["searchQueryV1"] + "?param=" + val + "&context=myfiles&page=0&limit=" + limit;        
        
        if(self.universalService.searchType == 'teamfolder' && this.universalService.currentTeamFolder){
          url = url + "&tfObjectKey=" + this.universalService.currentTeamFolder["objectKey"] + "&tfKey=" + this.universalService.currentTeamFolder["tfKey"];
        }
        if(self.searchQuerySubscriptionList[val]) {
          self.searchQuerySubscriptionList[val].unsubscribe();
        }
        self.searchQuerySubscriptionList[val] = this.http.get(url).subscribe(suc=>{
           self.searchQuerySuggestions = suc;
           self.searchQuerySuggestions["summary"] = self.searchQuerySuggestions.summary ? self.searchQuerySuggestions.summary : [];
           if(self.searchQuerySuggestions.faceNamesList) {
            self.searchQuerySuggestions.summary = self.searchQuerySuggestions.summary.concat(self.searchQuerySuggestions.faceNamesList)
           }
           if(self.searchQuerySuggestions.objects){
            self.searchQuerySuggestions.summary = self.searchQuerySuggestions.summary.concat(self.searchQuerySuggestions.objects)
           }
           self.searchQuerySuggestions["summary"] = self.searchQuerySuggestions["summary"].length>0?self.searchQuerySuggestions["summary"].slice(0,10):self.searchQuerySuggestions["summary"];

           self.queryResults[val] = self.searchQuerySuggestions;
           delete self.searchQuerySubscriptionList[val];
           resolve(suc)
        },err=>{
          reject(err)
        })
      }
    )
    
  }


  /** function to fetch results for a keyword  or a suggestion */
  /**  A search url as received in suggestion response is used to fetch search results 
   * in case of click on auto suggestion  whereas for other scenario search keyword API is used */
  searchKeyword(val,useSemanticAPI,searchUrl?:string){ 
    let self = this;
    val = encodeURIComponent(val);
    return new Promise((resolve, reject) => {
      self.userData = self.localStorageService.getUserData(true);
      const baseUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["aseURL"];
      let limit = ENV_CONFIG["constants"]["PAGE_LIMIT"] * ENV_CONFIG["constants"]["PAGINATION_BUFFER"];
      var url;
      if(useSemanticAPI){
        url = baseUrl + ENV_CONFIG.commonUrls["aiSearchKeywordV1"] + "?param=" + val +  "&page=0&limit=" + limit;
      }else{
        url = searchUrl ? baseUrl + searchUrl :  baseUrl + ENV_CONFIG["commonUrls"]["searchKeyword"] + "?param=" + val + '&context=myfiles' + "&page=0&limit=" + limit;
      }
      if(self.universalService.searchType == 'teamfolder'){
        url = url + "&tfObjectKey=" + this.universalService.currentTeamFolder["objectKey"] + "&tfKey=" + this.universalService.currentTeamFolder["tfKey"];
      }
      this.http.get(url).subscribe(suc=>{
         self.suggestedKeywordResults = suc;
         self.searchUrl = url
         resolve(suc)
      },err=>{
        reject(err)
      })
    })
  }
  
  /** Function to main and update search history when any search result is accessed */
  updateSearchHistory(searchObj) {
    this.historyList = this.getSearchHistory();
    const searchIndexInHistory = this.historyList.findIndex(obj =>  obj["objectName"]==searchObj["objectName"])
    // remove the oldest keyword search object if size greater than maxSearch
    if(searchIndexInHistory >=0){ // if the object exists in the search history
      var allIndexes = this.getAllIndexes(this.historyList,searchObj) // if the object was searched multiple times
      allIndexes.map(index=>{
        this.historyList.splice(index, 1);
      })
    }else if (this.historyList.length >= this.maxSearchHistory && searchIndexInHistory <0) {
      this.historyList.pop();
    }
    var array = [searchObj];
    this.historyList = array.concat(this.historyList);
    if(this.universalService.searchType == 'teamfolder'){
      localStorage.setItem("teamFolderSearchHistory", JSON.stringify(this.historyList));
      return
    }
    localStorage.setItem("searchHistory", JSON.stringify(this.historyList));
  }
/** Function to update search history OF FACES when any search result is accessed */
  updateFaceHistory(searchObj, oldFaceDetails?) {
    this.historyList = this.getSearchHistory();
    var searchIndexInHistory;
    if(oldFaceDetails != undefined)
      searchIndexInHistory =  this.historyList.findIndex(obj =>  obj["faceKey"]==oldFaceDetails["faceKey"])
    else  
      searchIndexInHistory =  this.historyList.findIndex(obj =>  obj["faceKey"]==searchObj["faceKey"])
    // remove the oldest keyword search object if size greater than maxSearch
    if(searchIndexInHistory >=0){ // if the object exists in the search history
      var allIndexes = this.getAllIndexesForFaces(this.historyList,oldFaceDetails?oldFaceDetails:searchObj) // if the object was searched multiple times
      allIndexes.map(index=>{
        this.historyList.splice(index, 1);
      })
    }else if (this.historyList.length >= this.maxSearchHistory && searchIndexInHistory <0) {
      this.historyList.pop();
    }
    var array = [searchObj];
    if(searchIndexInHistory >=0)
      this.historyList = array.concat(this.historyList);

    localStorage.setItem("searchHistory", JSON.stringify(this.historyList));
  }

  getSearchHistory(){
    var historyKey = "searchHistory";
    if(this.universalService.searchType == 'teamfolder'){
      historyKey = "teamFolderSearchHistory";
    }
    this.historyList = localStorage.getItem(historyKey) ? JSON.parse(localStorage.getItem(historyKey)) : [];
    return this.historyList;
  }

  /** API call to get file metadata using objectKey */
  getSearchItemInfo(objectKey,metadata={}){
    return new Promise((resolve, reject) => {
      var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls.info + objectKey + '/info';
      
      if(this.universalService.searchType == 'teamfolder'){
        url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["tmfldURL"] + ENV_CONFIG.commonUrls["teamFolderMetadata"] + "/" + objectKey + "/info?tfKey=" + metadata["tfKey"];
      }
      this.http.get(url).subscribe(suc=>{
         resolve(suc)
      },err=>{
        if(this.universalService.searchType == 'teamfolder'){
          this.universalService.showErrorMessage(err);
        }
      })
    })
  }

  getAllIndexes(arr, val) {
    var indexes = [], i = -1;
    // while ((i = arr.indexOf(val, i+1)) != -1){
    //     indexes.push(i);
    // }
    arr.map((obj,index)=>{
      if((obj["objectName"] == val["objectName"] && (obj["objectType"] == val["objectType"]) || (obj["objectName"] == val["objectName"] && obj["wordSearch"] == val["wordSearch"]))){
        indexes.push(index);
      }
    })
    return indexes;
  }

  getAllIndexesForFaces(arr, val) {
    var indexes = [], i = -1;
    arr.map((obj,index)=>{
      if((obj["faceKey"] == val["faceKey"]) || (obj["objectName"] == val["objectName"])){
        indexes.push(index);
      }
    })
    return indexes;
  }

  getTaggingSuggestionList(keyword){
    return new Promise((resolve, reject) => {
      const url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["aseURL"] + ENV_CONFIG.commonUrls.tagsSuggestions + '?param=' + keyword;
      
      this.http.get(url).subscribe(suc=>{
         resolve(suc)
      },err=>{
        reject(err)
      })
    })
  }
}
